export const selectedComparables = (comparables) => {
  return comparables.selected
    .map((id, i) => ({
      ...comparables.properties[id],
      featured: comparables.featured.includes(id),
      label: i >= 9999 ? null : (i + 1).toString(),
    }));
};
